import { useBack } from "../http";
import { EpiDashboardDTO } from "../types/EpiDashboardDTO";

export class EpiDashboardService {
	constructor() {}
	axiosInstance = useBack();

	async getDashboard(companyId: number, sector: string, from: string, to: string) {
		try {
			const encodedSector = encodeURIComponent(sector);
			const encodedFrom = encodeURIComponent(from);
			const encodedTo = encodeURIComponent(to);
			const response = await this.axiosInstance
				.get<EpiDashboardDTO>(
					`/epi-inspections/dashboard/${companyId}?sector=${encodedSector}&from=${encodedFrom}&to=${encodedTo}`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter o dashboard NR-06`, error);
			return undefined;
		}
	}
}